import { useRecoilState } from "recoil";
import { projectInfoState } from "../../recoil";

export function useProjectLabelClasses() {
  const [projectData, setProjectData] = useRecoilState(projectInfoState);

  const registerLabelClass = (label: string) => {
    const trimmed = label.trim();
    if (!trimmed) return;
    if (projectData?.class?.includes(trimmed)) return; // 이미 있으면 skip

    setProjectData((prev) => (prev ? { ...prev, class: [...prev.class, trimmed] } : prev));

    // TODO: 서버에도 반영 필요 — 아래 3번 참고
  };

  return { projectClasses: projectData?.class ?? [], registerLabelClass };
}
